/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_DRUG_TEST_CATEGORIES_QUERY } from "../../graphql/DrugTests/DrugTestCategories.graphql";
import { useCurrentUserRoles } from "../Authorization";

function DrugTestCategorySelect({
  variables,
  value,
  label,
  size,
  name,
  icon,
  onChange,
  readOnly,
  required,
  showHelp
}) {
  const roles = useCurrentUserRoles();
  const isAdmin = roles.some(role => role === "ADMIN");
  const isFleet = roles.some(role => role === "FLEET");
  const isBill = roles.some(role => role === "FIN");
  const { data, loading, error } = useQuery(ALL_DRUG_TEST_CATEGORIES_QUERY, {
    variables
  });
  return (
    <Field>
      {showHelp && (isAdmin || isFleet || isBill) ? (
        <Label
          as={Link}
          tabIndex="-1"
          textColor="link"
          to="/hr/drug-test-categories"
        >
          {label}
        </Label>
      ) : (
        <Label>{label}</Label>
      )}
      <Control iconLeft size={size}>
        <Select.Container
          fullwidth
          color={
            error ||
            (required && (value === "" || value === "0" || value === 0))
              ? "danger"
              : ""
          }
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select
            disabled={readOnly}
            name={name}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="">{label}</Select.Option>
            {!loading &&
              data?.DrugTestCategorys?.map((Category, i) => (
                <Select.Option
                  key={`employee-select-${i}`}
                  value={Category.RecId}
                >
                  {Category.Description}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
}

DrugTestCategorySelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  variables: PropTypes.object,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  showHelp: PropTypes.bool
};

DrugTestCategorySelect.defaultProps = {
  variables: { where: { Status: true }, orderByMulti: ["Description_ASC"] },
  showHelp: false
};
export default DrugTestCategorySelect;
